// FeedbackBadge.tsx
import { Badge } from '@/components/ui/badge';
import { FC } from 'react';

interface FeedbackBadgeProps {
  feedback?: boolean | null; // feedback can be boolean or null/undefined
}

const FeedbackBadge: FC<FeedbackBadgeProps> = ({ feedback }) => {
  if (feedback === null || feedback === undefined) {
    return null; // Don't render anything if feedback is null or undefined
  }

  return (
    <Badge
      variant={feedback ? 'info' : 'neutral'}
      size="sm"
      className={feedback ? 'bg-blue-600 text-white hover:bg-blue-600' : 'bg-slate-900 text-white hover:bg-slate-900'}
    >
      {feedback ? 'Rated Positive' : 'Rated Negative'}
    </Badge>
  );
};

export default FeedbackBadge;
